import { render, staticRenderFns } from "./CoursewareContentBookmarks.vue?vue&type=template&id=a574277e&"
import script from "./CoursewareContentBookmarks.vue?vue&type=script&lang=js&"
export * from "./CoursewareContentBookmarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports